import { createGenericFormSlice, SliceState } from "./genericFormSlice";
import { Assignment } from "../types";

const formSlice = createGenericFormSlice({
  name: "upsertAssignment",
  initialState: {} as SliceState<Assignment>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const upsertAssignmentReducer = formSlice.reducer;
export default upsertAssignmentReducer;
